(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('[data-lh-reading]').forEach((content) => {
      if (content.dataset.lhReady) return;
      content.dataset.lhReady = 'true';
      const region = content.closest('[data-lh-document]');
      const toc = region?.querySelector('[data-lh-toc]');
      const headings = [...content.querySelectorAll('h2')];
      if (toc && headings.length > 1) {
        const list = toc.querySelector('ul');
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `lh-topic-${content.id}-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
        });
        toc.hidden = false;
      }
      content.querySelectorAll('table').forEach((table) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'lh-table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', content.dataset.tableLabel || 'Comparison table');
        table.before(wrapper);
        wrapper.append(table);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
